import { SxProps, Theme } from '@mui/material';

/**
 * Paper gives the table its own surface, and the container scrolls rather than the page.
 * The same recipe as the other lists in the app.
 */
export const tableContainerStyles: SxProps<Theme> = {
    borderRadius: 3,
    border: '1px solid rgba(16,24,40,0.06)',
};

export const headerCellStyles: SxProps<Theme> = {
    fontWeight: 600,
    whiteSpace: 'nowrap',
};

/**
 * What the line is: a sheet's complaint, a document's title. Either can run to a paragraph.
 * Clamped so one long entry does not turn every other row into a sliver -- the full text is
 * in the document.
 */
export const descriptionCellStyles: SxProps<Theme> = {
    maxWidth: 360,
};

export const descriptionTextStyles: SxProps<Theme> = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

/**
 * The second line under a description: a sheet's pain level, the name a document had on the
 * device it came from. Quieter than the first, and clamped with it.
 */
export const descriptionDetailStyles: SxProps<Theme> = {
    display: 'block',
    color: 'text.secondary',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

/**
 * The description, on a card.
 *
 * Unlike the table cell this is allowed to run to several lines: a card has the room a
 * table column does not, and clamping it here would hide the one field somebody scanning
 * these is actually reading.
 */
export const descriptionCardValueStyles: SxProps<Theme> = {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
};

/** Who added the line: a name, which must not wrap into a column of single words. */
export const authorCellStyles: SxProps<Theme> = {
    whiteSpace: 'nowrap',
    color: 'text.secondary',
};

/** The date column: never wrapped, or "12 sept. 2026" becomes three lines. */
export const dateCellStyles: SxProps<Theme> = {
    whiteSpace: 'nowrap',
};

/** The way to the next page, centred under whichever of the two shapes is on screen. */
export const showMoreBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    mt: 2,
};

/**
 * The open button, and beside it the delete for whoever may use it. Wraps rather than widening
 * the column, so a narrow table cell or a card stacks the two instead of clipping one.
 */
export const rowActionsStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
};
